const sortOnDate = (a, b) =>
  new Date(b.properties.utcDate) - new Date(a.properties.utcDate);

export default (data) => data.sort(sortOnDate)[0];
